import { render, staticRenderFns } from "./FilterOptionsSegments.vue?vue&type=template&id=bd0d19f8&"
import script from "./FilterOptionsSegments.vue?vue&type=script&lang=js&"
export * from "./FilterOptionsSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports